import Vue from "vue";
import VueRouter from "vue-router";
import AdHome from "../views/AdHome.vue";
import AdTrialList from "../views/AdTrialList.vue";
import AdTrialDetails from "../views/AdTrialDetails";
import AdAboutUs from "../views/AdAboutUs";
import StaticTrialDetails from "../views/StaticTrialDetails";
import PrivacyPolicy from "../views/PrivacyPolicy";
import ThankYouPage from "../views/ThankYouPage";
import JoinTrials from "../views/JoinTrials";
import ThankYouForInterest from "../views/ThankYouForInterest.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: AdHome
  },
  // {
  //   path: "/about_us",
  //   name: "about-us",
  //   component: AdAboutUs
  // },
  // {
  //   path: "/trials",
  //   name: "trials-list",
  //   component: AdTrialList
  // },
  // {
  //   path: "/trials/:id",
  //   name: "trial_details",
  //   props: true,
  //   component: AdTrialDetails
  // },
  // {
  //   path: "/join-a-trial",
  //   name: "join-trials",
  //   props: true,
  //   component: JoinTrials
  // },
  // {
  //   path: "/thank-you-for-interest",
  //   name: "thank-you-for-interest",
  //   component: ThankYouForInterest
  // },
  // {
  //   path: "/thank-you/:id",
  //   name: "thank-you",
  //   props: true,
  //   component: ThankYouPage
  // },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: PrivacyPolicy
  }
];

if (process.env.NODE_ENV === "development") {
  routes.push({
    path: "/static_trial_page",
    name: "static_trial_details",
    props: true,
    component: StaticTrialDetails
  });
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.previousRoute) {
    // If the previous route is already set in meta, continue navigation
    next();
  } else {
    // Set the previous route in meta
    to.meta.previousRoute = from;
    next();
  }
});


export default router;
